import { Component, CUSTOM_ELEMENTS_SCHEMA, Input } from '@angular/core';
import { RouterLink } from '@angular/router';
import { MaterialModule } from '../../material.module';

@Component({
  selector: 'app-breadcrumb',
  standalone: true,
  imports: [MaterialModule],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  templateUrl: './breadcrumb.component.html',
  styleUrl: './breadcrumb.component.css',
})
export class BreadcrumbComponent {
  @Input('title') title: string = '';
  @Input('main-title') mainTitle: string = '';
  @Input() breadcrumbs: string[] = [];


   @Input() hide: boolean = false;
}
